export const regExps = {
  allSpace: /\s/g,
  allNumber: /\d/g,
  allKorean: /[ㄱ-ㅎㅏ-ㅣ가-힣]/g,
  koreanCompleteOrEng: /^[가-힣a-zA-Z]+$/,
  emailFormat: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  specialChar: /[{}[\]/?.,;:|~`!^_+<>@#$%='"]/g,
  allSpecialChar: /[{}[\]/?.,;:|*~`!^_+<>@#$%='"-*&()]/g,
  notNumber: /[^0-9]/g,
  addHyphen: /^(\d{0,3})(\d{0,4})(\d{0,4})$/g,
  plusHyphen: /(-{1,2})$/g,
  onlyNumEng: { replace: /[^a-zA-Z0-9\s]/g, pattern: /^[a-zA-Z0-9\s]*$/ },
  telReg: { replace: /[^0-9]/gi, pattern: /^[0-9]*$/ },
  numReg: { replace: /[^0-9]/gi, pattern: /^[0-9]*$/ },
  selfCouponName: {
    replace: /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9\s,.(){}\[\]]/g,
    pattern: /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9\s,.(){}\[\]]*$/,
  },
  detailAddr: /[^ㄱ-ㅎ가-힣0-9-&*()\s]/g,
}

export const NumReplace = (str: string, maxLength: number) =>
  str.replaceAll(regExps.numReg.replace, '').slice(0, maxLength)

/** 휴대폰 11자리 숫자만 받아 010-1234-5678 형태로 표시 */
export const formatMobileKo = (raw: string) => {
  const d = raw.replace(/\D/g, '').slice(0, 11)
  if (d.length <= 3) return d
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`
}

export const HyphenReplace = (str: string) => {
  if (regExps.numReg.pattern.test(str)) {
    return str.replace(regExps.addHyphen, '$1-$2-$3')
  } else {
    return str
  }
}
